import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-multi-column-modals.scss'

function initMultiColumnModals() {
    let contentCardWrappers = document.querySelectorAll(`.multi-column-content-card-wrapper`)

    // if 4 cards, expand max width
    if (contentCardWrappers.length === 4) {
        (document.getElementsByClassName(`multi-column-content-card-row`)[0]).style.maxWidth = `80%`
    }

    function showModal(modalElement) {
        modalElement.style.display = `block`
    }

    function activateBorder(contactCardElement) {
        contactCardElement.classList.add(`active`)
    }

    function deactivateBorder(contactCardElement) {
        contactCardElement.classList.remove(`active`)
    }

    function closeModal(modalElement) {
        modalElement.style.display = `none`
    }

    contentCardWrappers.forEach((contentCardWrapper) => {
        let clickATag = contentCardWrapper.querySelector(`.see-process`)
        let contentCard = contentCardWrapper.querySelector(`.multi-column-content-card`)
        let modal = contentCardWrapper.querySelector(`.modal`)
        let closeModalButton = contentCardWrapper.querySelector(`.close`)

        clickATag.addEventListener(`click`, () => {
            showModal(modal)
            activateBorder(contentCard)
        })

        modal.addEventListener(`click`, (e) => {
            if (e.target.className == `modal`) {
                closeModal(modal)
                deactivateBorder(contentCard)
            }
        })

        closeModalButton.addEventListener(`click`, () => {
            closeModal(modal)
            deactivateBorder(contentCard)
        })
    })
}


export default register(`section-multi-column-modals`, {

    onLoad() {
        initMultiColumnModals()
    },

    onUnload() {
    },
})